<template>
  <div class="p-absolute main_menu">
    <div class="container">
      <div class="columns">
        <div class="column col-xl-12 pt-2">
          <button v-on:click="closeMenu" @mouseenter="animMenuCloseBtn" @mouseleave="animMenuCloseBtnRev" id="close_btn">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
              <g id="Layer_5">
                <g>
                  <radialGradient id="SVGID_11_" cx="98.3133" cy="101.7756" r="86.3822" gradientTransform="matrix(1.1576 0 0 1.1576 -13.812 -17.82)" gradientUnits="userSpaceOnUse">
                    <stop  offset="0" style="stop-color:#005E66"/>
                    <stop  offset="0.8587" style="stop-color:#005E66;stop-opacity:0.2272"/>
                    <stop  offset="1" style="stop-color:#005E66;stop-opacity:0.1"/>
                  </radialGradient>
                  <circle style="fill:url(#SVGID_11_);" cx="100" cy="100" r="100"/>
                </g>
              </g>
              <g>
                <g>
                  <circle style="fill:#00BED0;" cx="100" cy="100" r="83.2"/>
                  <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="16.7634" y1="100" x2="183.2366" y2="100">
                    <stop  offset="5.618001e-03" style="stop-color:#41354D"/>
                    <stop  offset="0.6101" style="stop-color:#41354D"/>
                    <stop  offset="0.8039" style="stop-color:#41354D"/>
                    <stop  offset="0.8379" style="stop-color:#68295B"/>
                    <stop  offset="0.8931" style="stop-color:#A1186F"/>
                    <stop  offset="0.9405" style="stop-color:#CA0B7E"/>
                    <stop  offset="0.9777" style="stop-color:#E40388"/>
                    <stop  offset="1" style="stop-color:#ED008B"/>
                  </linearGradient>
                  <path style="fill:url(#SVGID_4_);" d="M100,40.8c32.7,0,59.2,26.6,59.2,59.2s-26.6,59.2-59.2,59.2S40.8,132.7,40.8,100
                    S67.3,40.8,100,40.8 M100,16.8C54,16.8,16.8,54,16.8,100S54,183.2,100,183.2s83.2-37.3,83.2-83.2S146,16.8,100,16.8L100,16.8z"/>
                </g>
                <g>
                  <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M66.3,110.7c-1.6,1.1-3.5,1.7-5.8,1.7c-2.1,0-3.9-0.5-5.4-1.4
                    c-1.5-0.9-2.7-2.2-3.5-4c-0.8-1.7-1.2-3.8-1.2-6.2c0-2.4,0.4-4.4,1.2-6.2c0.8-1.7,2-3.1,3.5-4c1.5-0.9,3.3-1.4,5.4-1.4
                    c2.2,0,4.1,0.5,5.7,1.5c1.6,1,2.6,2.6,3.1,4.6l-4.7,2.1c-0.3-1.4-0.7-2.3-1.3-2.9c-0.6-0.5-1.5-0.8-2.6-0.8
                    c-1.5,0-2.7,0.6-3.5,1.8c-0.8,1.2-1.2,2.9-1.2,5.2s0.4,4,1.2,5.2c0.8,1.2,2,1.8,3.5,1.8c1.1,0,2-0.3,2.7-0.9
                    c0.7-0.6,1.1-1.5,1.4-2.8l4.9,1.5C69,107.9,67.9,109.6,66.3,110.7z"/>
                  <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M88.2,107.5v4.5H72.6V89.6h5.4v17.9H88.2z"/>
                  <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M105.3,90.6c1.5,0.9,2.7,2.2,3.5,4c0.8,1.7,1.2,3.8,1.2,6.2
                    s-0.4,4.5-1.2,6.2c-0.8,1.7-2,3.1-3.5,4c-1.5,0.9-3.3,1.4-5.4,1.4c-2.1,0-3.9-0.5-5.4-1.4c-1.5-0.9-2.7-2.2-3.5-4
                    c-0.8-1.7-1.2-3.8-1.2-6.2s0.4-4.5,1.2-6.2c0.8-1.7,2-3.1,3.5-4c1.5-0.9,3.3-1.4,5.4-1.4C102,89.3,103.8,89.7,105.3,90.6z
                     M96.5,95.6c-0.8,1.2-1.2,2.9-1.2,5.2c0,2.3,0.4,4,1.2,5.2c0.8,1.2,1.9,1.8,3.4,1.8c1.5,0,2.6-0.6,3.4-1.8
                    c0.8-1.2,1.2-2.9,1.2-5.2c0-2.3-0.4-4-1.2-5.2c-0.8-1.2-1.9-1.8-3.4-1.8C98.4,93.9,97.3,94.4,96.5,95.6z"/>
                  <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M126.5,90.2c1.4,0.6,2.7,1.7,3.9,3.1l-3,3.8
                    c-0.7-1.1-1.5-2-2.4-2.5c-0.9-0.5-2-0.8-3.3-0.8c-1.1,0-1.9,0.2-2.5,0.6c-0.6,0.4-0.9,1-0.9,1.6c0,0.6,0.3,1,0.9,1.4
                    c0.6,0.4,1.7,0.7,3.1,1c2.8,0.6,4.9,1.4,6.1,2.5c1.2,1.1,1.8,2.6,1.8,4.6c0,1.4-0.4,2.7-1.1,3.7c-0.7,1-1.8,1.8-3.1,2.4
                    c-1.3,0.5-2.8,0.8-4.5,0.8c-2.3,0-4.2-0.3-5.7-0.9c-1.5-0.6-2.7-1.6-3.8-2.9l2.7-4.1c0.8,1.2,1.7,2.1,2.7,2.6
                    c1,0.5,2.2,0.7,3.7,0.7c1.1,0,2-0.2,2.6-0.5c0.6-0.4,0.9-0.9,0.9-1.5c0-0.5-0.3-0.9-0.9-1.3c-0.6-0.3-1.6-0.6-3.1-0.9
                    c-1.8-0.4-3.2-0.8-4.4-1.4c-1.2-0.5-2-1.3-2.7-2.2c-0.6-0.9-1-2.1-1-3.5c0-1.4,0.3-2.7,1-3.8c0.7-1.1,1.7-2,3.1-2.6
                    c1.3-0.6,2.9-0.9,4.8-0.9C123.5,89.3,125.1,89.6,126.5,90.2z"/>
                  <path class="menu_letter" style="fill:#41354D;stroke:#41354D;stroke-miterlimit:10;" d="M150,107.5v4.5h-16.4V89.6h16v4.5h-10.7v4.6h8.5v4.2h-8.5v4.6
                    H150z"/>
                </g>
              </g>
              <g id="Layer_6">
                <g>
                  <circle style="fill:#ED008B;" cx="171.6" cy="100" r="15.7"/>
                </g>
              </g>
              </svg>
          </button>
          <div class="main_menu__list_cnt">
            <h1>&lt;MENU&gt;</h1>
            <ul class="main_menu_list">
              <li>
                <router-link to="/" @click.native="closeMenu">HOME</router-link>
              </li>
              <li>
                <router-link to="/contact" @click.native="closeMenu">Contact</router-link>
              </li>
              <li>
                <router-link v-if="$route.path === '/contact'" to="/about" @click.native="closeMenu">About</router-link>
                <a v-else @click.prevent="scrollToSectionFromMenu('.second_section', 'about')" href="#">About</a>
              </li>
              <li>
                <router-link v-if="$route.path === '/contact'" to="/projects" @click.native="closeMenu">Projects</router-link>
                <a v-else @click.prevent="scrollToSectionFromMenu('.third_section', 'projects')" href="#">Projects</a>
              </li>
            </ul>
            <h1>&lt;/MENU&gt;</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default{
  name: 'Menu',
  props: {
    menuIsOpened:{
      type: Boolean
    },
    closeM:{
      type: Function
    }
  },
  mounted(){
    let menuBtnCloseSvg = document.getElementById('Layer_5')
    let menuBtnCloseSvg2 = document.getElementById('Layer_6')
    let btnCloseTimeLineAnim = new TimelineMax({repeat:-1})
    btnCloseTimeLineAnim.timeScale(1.2)
    btnCloseTimeLineAnim
    .to(menuBtnCloseSvg, 1, {scale: 0.82, transformOrigin:"50% 50%", ease: Power0.easeNone} )
    .to(menuBtnCloseSvg, 1, {scale:1, transformOrigin:"50% 50%", ease: Power0.easeNone} )
    .to(menuBtnCloseSvg2, 1, {scale: 0, transformOrigin:"50% 50%", ease: Power1.easeIn}, '-=2')
    .to(menuBtnCloseSvg2, 1, {scale: 1, transformOrigin:"50% 50%", ease: Power1.easeIn}, '-=1')
  },
  methods:{
    closeMenu(){
      this.closeM() 
    },
    animMenuCloseBtn(){
      let letters = document.getElementsByClassName('menu_letter')
      TweenLite.to(letters, 0.3, {css:{ fill: '#ED008B', stroke:'#ED008B' }, ease: Power1.easeOut})
    },
    animMenuCloseBtnRev(){
      let letters = document.getElementsByClassName('menu_letter')
      TweenLite.to(letters, 0.3, {css:{ fill: '#41354D', stroke:'#41354D' }, ease: Power1.easeIn})
    },
    scrollToSectionFromMenu(element, path){
      this.closeMenu()
      this.$router.push({ path: path })
      document.documentElement.classList.remove('overflow_is_active')
      document.body.classList.remove('overflow_y_is_active')
      let el = document.querySelector(element)
      let scrollMinTime = Math.floor(el.offsetTop / 100) / 10
      let scrollTime = Math.max(scrollMinTime, 1)
      TweenLite.to(window, scrollTime, {scrollTo: el, ease: Power2.easeOut, delay: 0.25})
    },
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.main_menu{
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  pointer-events: none;
  background: url(../assets/images/soft-pad.png);
  background-color: $pale_blue;
  overflow-y: auto;
  max-width: 100vw;
  max-height: 100vh;
  &__list_cnt{
    padding-left: 128px;
    .main_menu_list{
      list-style: none;
      font-weight: bold;
      font-size: 1.5rem;
      text-transform: uppercase;
      a{
        transition: color 0.2s linear;
        color: $dirty-vel;
        &:hover{
          color: darken($pink, 2);
        }
      }
    }
  }
  #close_btn{
    width: 128px;
    height: 128px;
    border-radius: 50%;
    background-color: transparent;
    border: none;
    outline: none;
    -webkit-appearance: none;
    padding: 0;
    cursor: pointer;
  }
  h1{
    color: #3b4351;
  }
  h1:last-of-type{
    padding-left: 4rem;
  }
}
</style>
